export default function defaultBoardGroup() {
  return {
    name: 'Conjunto de módulos',
    description: 'conjunto de módulos',
    groups: [
      {
        name: 'Módulo 1',
        boardIds: [],
      },
      {
        name: 'Módulo 2',
        boardIds: [],
      },
      {
        name: 'Módulo 3',
        boardIds: [],
      },
    ],
  };
}
